import { deepMerge } from 'js/utils/Utils'
import { PlaneGeometry } from 'three'
import BgLPlaneMesh from 'js/webgl/customMeshes/BgLPlaneMesh'
import BgColorPlaneMesh from 'js/webgl/customMeshes/BgColorPlaneMesh'
import ListThumbAPlaneMesh from 'js/webgl/customMeshes/ListThumbAPlaneMesh'
import ListThumbBPlaneMesh from 'js/webgl/customMeshes/ListThumbBPlaneMesh'

const defaults = {
  instanceName: 'careerHomeWebgl',
  $names: {
    bgL: '[data-gl-item="bg-l"]',
    bg: '[data-gl-item="bg"]',
    listThumbA: '[data-gl-item="list-thumb-a"]',
    listThumbB: '[data-gl-item="list-thumb-b"]',
  },
  dataNames: {},
}

export default class CareerHomeWebgl {
  $contentRoot = document
  $bgLs = []
  $bgs = []
  $listThumbAs = []
  $listThumbBs = []
  meshesItems = []

  bgLMeshes = []
  bgMeshes = []
  listThumbAMeshes = []
  listThumbBMeshes = []
  originalPlaneGeometry = null

  constructor(options = {}) {
    deepMerge(this, defaults, options)
  }

  init() {
    this._set$()
    this._setMeshes()
    this._addEventListeners()
    this._addGUI()
  }

  destroy() {
    this._removeGUI()
    this._removeEventListeners()
    this._clearMesh()
  }

  _set$() {
    this.$bgLss = this.$contentRoot.querySelectorAll(this.$names.bgL)
    this.$bgs = this.$contentRoot.querySelectorAll(this.$names.bg)
    this.$listThumbAs = this.$contentRoot.querySelectorAll(this.$names.listThumbA)
    this.$listThumbBs = this.$contentRoot.querySelectorAll(this.$names.listThumbB)
  }

  _setMeshes() {
    this.meshesItems = []
    this.originalPlaneGeometry = new PlaneGeometry(1, 1, 1, 1)

    this.bgMeshes = []
    this.$bgs.forEach(($bg, i) => {
      this.bgMeshes[i] = new BgColorPlaneMesh({
        webgl: this,
        $target: $bg,
        geometry: this.originalPlaneGeometry,
        instanceName: `careerHomeWebgl-bg-${i}`,
        index: i,
        effectInfo: {
          color: '#0d0d0d',
        },
      })
    })

    this.bgLMeshes = []
    this.$bgLss.forEach(($bgL, i) => {
      this.bgLMeshes[i] = new BgLPlaneMesh({
        webgl: this,
        $target: $bgL,
        geometry: this.originalPlaneGeometry,
        instanceName: `careerHomeWebgl-bgL-${i}`,
        index: i,
        isFV: i === 0,
      })
    })

    this.listThumbAMeshes = []
    this.$listThumbAs.forEach(($listThumbA, i) => {
      this.listThumbAMeshes[i] = new ListThumbAPlaneMesh({
        webgl: this,
        $target: $listThumbA,
        geometry: this.originalPlaneGeometry,
        instanceName: `careerHomeWebgl-listThumbA-${i}`,
        index: i,
        effectInfo: {
          bgColor1: '#2b2b2b',
        },
      })
    })

    this.listThumbBMeshes = []
    this.$listThumbBs.forEach(($listThumbB, i) => {
      this.listThumbBMeshes[i] = new ListThumbBPlaneMesh({
        webgl: this,
        $target: $listThumbB,
        geometry: this.originalPlaneGeometry,
        instanceName: `careerHomeWebgl-listThumbB-${i}`,
        index: i,
        effectInfo: {
          bgColor1: '#2b2b2b',
        },
      })
    })

    this.meshesItems.push(this.bgMeshes)
    this.meshesItems.push(this.bgLMeshes)
    this.meshesItems.push(this.listThumbAMeshes)
    this.meshesItems.push(this.listThumbBMeshes)

    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.init()
      })
    })

    if (this.originalPlaneGeometry) {
      this.originalPlaneGeometry.dispose()
      this.originalPlaneGeometry = null
    }
  }

  _clearMesh() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.destroy()
        mesh = null
      })
    })
    this.meshesItems = []
  }

  _addEventListeners() {}

  _removeEventListeners() {}

  fvAnimation() {
    this.bgLMeshes[0]?.fvAnimation()
  }

  onResize() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onResize()
      })
    })
  }

  onRaf() {
    this.meshesItems.forEach((meshesItem) => {
      meshesItem.forEach((mesh) => {
        mesh.onRaf()
      })
    })
  }

  _addGUI() {
    // const meshes = []
    // meshes.forEach((mesh) => {
    //   if (mesh && mesh._addGUI) {
    //     mesh._addGUI()
    //   }
    // })
  }

  _removeGUI() {
    // this.meshesItems.forEach((meshesItem) => {
    //   meshesItem.forEach((mesh) => {
    //     mesh._removeGUI()
    //   })
    // })
  }
}